import { RuleID } from '@forto-dev/insights-engine-models'
import { CustomerAccountNotification } from '@forto-dev/renderer-templates'

import { FeedItem } from '../domain/feed'

export const feedActivityToCustomerAccountNotificationMapper = (response: FeedItem): CustomerAccountNotification => {
  return {
    id: '',
    activityID: response.activity.customField.sourceActivityID ?? '',
    customerID: response.feedInfo.customerID,
    type: (response.activity.customField as unknown as CustomerAccountNotification['data'])?.riskCategory ?? 'update',
    entity: {
      id: response.activity.object.id ?? '',
      type: response.activity.object.type,
    },
    data: response.activity.customField as unknown as CustomerAccountNotification['data'], // since for insights the data field get saved as customField
    createdAt: response.activity.createdAt,
    updatedAt: response.updatedAt,
    ruleID: response.activity.customField.ruleID as RuleID,
    context: response.feedInfo.context ?? {},
    insightID: '', // Needed for workflow approval links but not required for AF
  }
}
